import { createFileRoute } from '@tanstack/react-router'
import FileStorage from '@/features/file-storage'

export const Route = createFileRoute('/_authenticated/ke-toan/')({
  component: FileStorage,
}) 